import { Accordion } from '@cleartax/wg-library-accordian';
import { trackAction } from '../../../../../../../../shared';

const accordianClass =
  'border-sm rounded-full w-6 h-6 flex items-center justify-center';
const customIconFAQ = {
  open: <p className={accordianClass}>+</p>,
  close: <p className={accordianClass}>-</p>,
};

export interface IFAQ {
  question: React.ReactNode;
  answer: React.ReactNode;
}

export const FAQ: React.FC<IFAQ> = ({ question, answer }) => {
  return (
    <Accordion
      header={question}
      className={`border-b-sm border-grey-300 text-s-20 sm:border-x-0 sm:rounded-none sm:border-dashed sm:mt-0`}
      detailPanelClasses="overflow-x-hidden text-base pb-6 font-medium text-grey-900 justify-start sm:py-5"
      accordianHeaderEleClasses="font-bold text-grey-900 py-6 my-0 text-s-20 sm:my-auto sm:text-base sm:font-medium"
      customIcon={customIconFAQ}
      accordionIconClasses="text-grey-600 border-grey-600"
      onClick={() => {
        trackAction('click', question, { label: 'toggle_faq' });
      }}
    >
      {answer}
    </Accordion>
  );
};
